import {Injectable} from '@angular/core';
import {ignoreDomainSwitchHttpStatus, L1L3AuthService, SwitchDomainService} from 'ngx-auth-util-lib';
import {DomainType, MultiDomainProfile} from 'ngx-heka-design-lib';
import {environment} from 'src/environments/local/environment';
import {LoadingService} from './loading/loading.service';
import {Router} from '@angular/router';
import {multiDomainMgmtRoute} from '../models/multi-domain';

/**
 * Similar to other app's but intentionally not in library because of routing reason.
 */
@Injectable({
  providedIn: 'root'
})
export class DomainHandlerService {
  constructor(
    private switchDomainService: SwitchDomainService,
    private loadingService: LoadingService,
    private router: Router,
    private authService: L1L3AuthService
  ) {
  }

  public switchDomainAndReload(domainId: string) {
    this.loadingService.setLoading(true);
    this.switchDomainService.switchDomain(domainId).subscribe({
      next: () => this.reloadApplication(),
      error: err => {
        if (err?.status != ignoreDomainSwitchHttpStatus) {
          this.loadingService.setLoading(false);
          throw err;
        }
        this.reloadApplication();
      }
    });
  }

  public reloadApplication(targetPath?: string) {
    // special handling, only for this application with this route:
    if (this.router.url.includes(multiDomainMgmtRoute)) {
      window.location.reload();
    } else if (targetPath) {
      window.location.href = `${environment.redirect.host}/${targetPath}`;
    } else {
      window.location.href = environment.redirect.host;
    }
  }

  public handleActiveDomainRemoved(profile: MultiDomainProfile, reloadTargetPath?: string, electedDomainId?: string) {
    const leftDomain = profile.domains.find(d => d.active);
    const leftDomains = profile.domains.filter(
      d => d.domainId != leftDomain?.domainId && d.domainType == DomainType.JOINED
    );

    if (leftDomains.length > 0 && electedDomainId) {
      this.switchDomainService.switchDomain(electedDomainId).subscribe({
        error: err => {
          // here the refresh-logic would not be triggered, so instead reloading the application.
          this.reloadApplication(reloadTargetPath);
        },
        complete: () => (window.location.href = environment.links.applications.hcp)
      });
    } else {
      this.authService.clearL3Token();
      this.reloadApplication(multiDomainMgmtRoute);
    }
  }
}
